import { JButton } from '@atoms/JButton';
import { Stack, Typography } from '@mui/material';
import 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmCancelPopUpsProps {
  onCancel: () => void;
  onClose: () => void;
}

const ConfirmCancelPopUps = ({
  onCancel,
  onClose,
}: ConfirmCancelPopUpsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography>
        {t('ARE_YOU_SUREYOU_WANT_TO_CANCEL_THIS_TOP_UPS')}
      </Typography>
      <Stack direction={'row'} gap={2} mt={2}>
        <JButton onClick={onCancel} variant="contained" color="error">
          {t('CANCEL_TOP_UPS')}
        </JButton>
        <JButton onClick={onClose} variant="contained" color="info">
          {t('BACK')}
        </JButton>
      </Stack>
    </>
  );
};

export default ConfirmCancelPopUps;
